var cultureKey = 'language'
var cultureOverrideKey = 'languageOverride'

function toLower(value: string) {
  return (value || '').toLowerCase()
}

function startsWithIgnoreCase(value: string, prefix: string) {
  return toLower(value).startsWith(toLower(prefix))
}

export function normalizeCulture(culture: string) {
  return startsWithIgnoreCase(culture, 'fr') ? 'fr-CA' : 'en-CA'
}

export function culturesMatch(a: string, b: string) {
  return toLower(normalizeCulture(a)) === toLower(normalizeCulture(b))
}

export function getStoredCulture() {
  var stored = localStorage.getItem(cultureKey)
  if (stored && startsWithIgnoreCase(stored, 'fr')) {
    return 'fr-CA'
  }
  if (stored && startsWithIgnoreCase(stored, 'en')) {
    return 'en-CA'
  }
  return 'en-CA'
}

export function setStoredCulture(culture: string) {
  localStorage.setItem(cultureKey, normalizeCulture(culture))
}

export function setCultureCookie(culture: string) {
  var normalized = normalizeCulture(culture)
  var cultureEscaped = encodeURIComponent(normalized)
  var cvalue = `c=${cultureEscaped}|uic=${cultureEscaped}`
  document.cookie = `.AspNetCore.Culture=${cvalue};path=/;max-age=${60 * 60 * 24 * 90}`
}

export function applyCultureLocally(culture: string) {
  var normalized = normalizeCulture(culture)
  setStoredCulture(normalized)
  setCultureCookie(normalized)
  return normalized
}

/** True when the user picked FR/EN in the nav; preferred-language sync must not override it. */
export function hasCultureOverride() {
  return !!sessionStorage.getItem(cultureOverrideKey)
}

export function setCultureOverride(culture: string) {
  sessionStorage.setItem(cultureOverrideKey, normalizeCulture(culture))
}

export function clearCultureOverride() {
  sessionStorage.removeItem(cultureOverrideKey)
}

export function switchCulture(culture: string) {
  var normalized = applyCultureLocally(culture)
  setCultureOverride(normalized)
  window.location.reload()
}

export function getTwoLetterCulture(culture: string) {
  return startsWithIgnoreCase(culture, 'fr') ? 'fr' : 'en'
}

export function getAuthUiLocales(culture: string) {
  return getTwoLetterCulture(culture) === 'en' ? 'en' : 'fr-CA'
}
